import { render } from "./MiniListLastChatsComp.vue?vue&type=template&id=07c514be&scoped=true"
import script from "./MiniListLastChatsComp.vue?vue&type=script&lang=js"
export * from "./MiniListLastChatsComp.vue?vue&type=script&lang=js"

import "./MiniListLastChatsComp.vue?vue&type=style&index=0&id=07c514be&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c514be"]])

export default __exports__